module.exports = __webpack_public_path__ + "img/tasting.4ed04e91.png";